import { Collapse, Container, Navbar, NavbarToggler, Row } from "reactstrap";
import React, { useState } from "react";
import BackButton from "../../BackButton";
import Link from "next/link";
import Menu from "./Menu";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Index = function Index(props) {
  var _useState = useState(false),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("header", {
      className: "header ".concat(props.headerClasses ? props.headerClasses : ""),
      children: /*#__PURE__*/_jsx(Navbar, {
        color: "white",
        light: true,
        dark: false,
        fixed: "top",
        expand: "lg",
        className: props.nav.classes ? props.nav.classes : "",
        children: /*#__PURE__*/_jsxs(Container, {
          fluid: true,
          children: [!props.showLogo && /*#__PURE__*/_jsx("div", {
            className: "mobile-cottage-search-menu",
            children: /*#__PURE__*/_jsx(BackButton, {})
          }), props.showLogo && /*#__PURE__*/_jsx(Link, {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/_jsx("a", {
              className: "py-1 navbar-brand",
              children: /*#__PURE__*/_jsx("img", {
                src: "/logo.png",
                width: "138",
                height: "31",
                alt: "Cottage Centre logo"
              })
            })
          }), /*#__PURE__*/_jsx(NavbarToggler, {
            onClick: function onClick() {
              return setCollapsed(!collapsed);
            },
            className: "navbar-toggler-right",
            children: /*#__PURE__*/_jsx("i", {
              className: "fa fa-bars"
            })
          }), /*#__PURE__*/_jsx(Collapse, {
            isOpen: collapsed,
            className: "offcanvas-collapse",
            children: /*#__PURE__*/_jsx(Menu, {
              onMenuClick: function onMenuClick() {
                return setCollapsed(false);
              }
            })
          })]
        })
      })
    })
  });
};

export default Index;